function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { delUrlParam } from '@/utils/index';
import { getStr } from '@/api/version/index';
import OSS from 'ali-oss';
export default {
  name: 'UploadByOss',
  props: {
    // 按钮文字
    btnText: {
      type: String,
      default: '点击上传视频'
    },
    // 文件上传路径
    fileURL: {
      type: String,
      default: ''
    },
    // 文件上传个数
    limit: {
      type: Number,
      default: 1
    },
    // 文件大小
    fileSize: {
      type: Number,
      default: 0
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 按钮是否禁用
    btnDisabled: {
      type: Boolean,
      default: false
    },
    // 文件list
    fileArray: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      fileList: [],
      // oss参数
      ossParams: undefined,
      stsToken: "",
      accessKeyId: '',
      accessKeySecret: '',
      // oss对象
      client: undefined,
      progressFlag: false
    }, _defineProperty(_ref, "ossParams", ''), _defineProperty(_ref, "fileType", ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/quicktime', 'video/rmvb']), _ref;
  },
  computed: {
    // 是否显示提示
    showTip: function showTip() {
      return this.isShowTip && (this.fileType || this.fileSize || this.limit);
    }
  },
  watch: {
    fileArray: {
      handler: function handler(val) {
        if (val.length === 0) {// this.fileList = []
        }
      },
      immediate: true
    }
  },
  created: function created() {
    // 获取oss参数
    // StsTokens({}).then((response) => {
    this.initoss(); // this.ossParams = {
    //   accessKeyId: 'LTAI5t8PJFD9AQxA8D4i7dHD',
    //   accessKeySecret: '7EQ8OoDntwNbcAwiHEGHvyFvVYVGkD'
    // }
    // this.client = new OSS({
    //   // region: this.ossParams.region,
    //   accessKeyId: this.ossParams.accessKeyId,
    //   accessKeySecret: this.ossParams.accessKeySecret,
    //   bucket: 'oss-bijie',
    //   endpoint: 'oss-cn-shenzhen.aliyuncs.com'
    //   // bucket: 'bijieoss',
    //   // endpoint: 'oss-cn-hongkong.aliyuncs.com'
    //   // endpoint: this.ossParams.endpoint
    // })
    // })
  },
  methods: {
    initoss: function initoss() {
      var _this = this;

      getStr({}).then(function (res) {
        // console.log('123' + res)
        _this.stsToken = res.securityToken;
        _this.accessKeyId = res.accessKeyId;
        _this.accessKeySecret = res.accessKeySecret;

        _this.initsdk();
      }).catch(function () {});
    },
    initsdk: function initsdk() {
      var _this2 = this;

      this.ossParams = {
        accessKeyId: this.accessKeyId,
        accessKeySecret: this.accessKeySecret
      };
      this.client = new OSS({
        // region: this.ossParams.region,
        accessKeyId: this.ossParams.accessKeyId,
        accessKeySecret: this.ossParams.accessKeySecret,
        bucket: 'oss-bijie',
        endpoint: 'oss-cn-shenzhen.aliyuncs.com',
        stsToken: this.stsToken,
        refreshSTSToken: function () {
          var _refreshSTSToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var _yield$getSts, res;

            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return getSts();

                  case 2:
                    _yield$getSts = _context.sent;
                    res = _yield$getSts.data;
                    return _context.abrupt("return", {
                      accessKeyId: _this2.ossParams.accessKeyId,
                      // 自己账户的accessKeyId或临时秘钥
                      accessKeySecret: _this2.ossParams.accessKeySecret,
                      // 自己账户的accessKeySecret或临时秘钥
                      stsToken: _this2.stsToken //  从STS服务获取的安全令牌（SecurityToken）。

                    });

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function refreshSTSToken() {
            return _refreshSTSToken.apply(this, arguments);
          }

          return refreshSTSToken;
        }(),
        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 3600 * 1000 // bucket: 'bijieoss',
        // endpoint: 'oss-cn-hongkong.aliyuncs.com'
        // endpoint: this.ossParams.endpoint

      });
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.error("\u5F53\u524D\u9650\u5236\u9009\u62E9".concat(this.limit, "\u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ").concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + this.fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    beforeUpload: function beforeUpload(file) {
      var _this3 = this;

      // 校验文件数量
      // console.log(this.fileList.length, this.limit)
      // if (this.fileList.length >= this.limit) {
      //   this.$message.error(`当前限制选择${this.limit}个文件`)
      //   return false
      // }
      // 校检文件类型
      if (this.fileType) {
        var fileExtension = '';

        if (file.name.lastIndexOf('.') > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
        }

        var isTypeOk = this.fileType.some(function (type) {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });

        if (!isTypeOk) {
          this.$message.error("\u6587\u4EF6\u683C\u5F0F\u4E0D\u6B63\u786E, \u8BF7\u4E0A\u4F20".concat(this.fileType.join('/'), "\u683C\u5F0F\u6587\u4EF6!"));
          return false;
        }
      } // 校检文件大小


      if (this.fileSize) {
        var isLt = file.size / 1024 / 1024 < this.fileSize;

        if (!isLt) {
          this.$message.error("\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ".concat(this.fileSize, " MB!"));
          return false;
        }
      } // zwy后添加 ↑


      var fileList = {};

      for (var key in file) {
        fileList[key] = file[key];
      } // status:uploading、success、error 文件上传状态


      var Name = file.name;
      var fileName = Name.substr(0, Name.indexOf('.'));
      var suffix = Name.substr(Name.indexOf('.'));
      var obj = this.timestamp('{y}{m}{d}{h}{i}{s}');
      var storeAs = '/' + 'dev' + '/' + this.timestamp('{y}-{m}-{d}') + '/' + 'video' + '/' + fileName + obj + suffix; //  路径+时间戳+后缀名

      fileList.storeAs = storeAs;
      file.storeAs = storeAs; // 默认为空

      this.fileList = [];
      this.progressFlag = true;
      this.fileList.push(_objectSpread(_objectSpread({}, fileList), {}, {
        progress: 0,
        status: 'uploading'
      }));
      this.sendFile(file, function (parms) {
        // progress 文件上传进度
        _this3.showProgress(fileList, parms);
      }); // 阻止 el-upload的默认上传

      return false;
    },
    showProgress: function showProgress(file, parms) {
      var progress = parms.progress,
          status = parms.status;

      var arr = _toConsumableArray(this.fileList).map(function (items) {
        if (items.uid === file.uid) {
          items.progress = progress;
          items.status = status;
        }

        return items;
      });

      this.fileList = _toConsumableArray(arr);
    },

    /**
     * 删除文件
     */
    handleRemove: function handleRemove(file) {
      var _this4 = this;

      this.fileList.forEach(function (item, index) {
        if (item.uid === file.uid) {
          _this4.fileList.splice(index, 1);
        }
      });
      this.$emit('uploadFile', this.fileList);
      this.videoPath = '';
      this.$emit('handleVideo', this.videoPath);
    },
    sendFile: function sendFile(file, callback) {
      var that = this; //  这里是OSS

      var _progress = 0;
      var f = file;
      this.client.multipartUpload(file.storeAs, f, {
        progress: function progress(p, checkpoint) {
          // 如果需要显示上传进度则需要使用progress函数
          _progress = Math.floor(p * 100);
          callback({
            progress: _progress,
            status: 'uploading'
          });
        },
        headers: {
          'Content-Disposition': "attachment; filename=".concat(encodeURIComponent(f.name)),
          'Cache-Control': 'public, no-cache'
        }
      }).then(function (result) {
        var url = delUrlParam(result.res.requestUrls[0], 'uploadId');
        that.fileList.forEach(function (item) {
          if (item.storeAs === result.name) {
            item.ossUrl = url;
          }
        });
        that.asyncImgChecked(url).then(function (res) {
          //  单独拿出来给动态视频加的方法
          that.$emit('handleVideoList', res);
          that.progressFlag = false;
        });
        callback({
          progress: _progress,
          status: 'success'
        });
        that.$emit('handleVideo', url); // that.$emit('uploadFile', that.fileList)
      });
    },
    // 获取+时长+宽高+宽高比
    asyncImgChecked: function asyncImgChecked(file) {
      return new Promise(function (resolve, reject) {
        var video = document.createElement('video');
        video.src = file;

        video.oncanplay = function () {
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          canvas.setAttribute('width', 100);
          canvas.setAttribute('height', 100);
          video.setAttribute('width', 100);
          video.setAttribute('height', 100);
          ctx.drawImage(video, 0, 0, video.width, video.height);
          var videoAspectRatio = video.videoWidth / video.videoHeight;
          var videoAspectRatioType = 0;

          if (video.videoWidth > video.videoHeight) {
            videoAspectRatioType = 1;
          } else if (video.videoWidth === video.videoHeight) {
            videoAspectRatioType = 2;
          } else {
            videoAspectRatioType = 3;
          }

          resolve({
            videoDuration: parseInt(video.duration % 60),
            // 得到整数的视频时长
            width: video.videoWidth,
            height: video.videoHeight,
            videoAspectRatio: videoAspectRatio,
            videoAspectRatioType: videoAspectRatioType
          });
        };
      });
    },
    //  时间戳
    timestamp: function timestamp(format) {
      var time = new Date();
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      var ms = time.getMilliseconds();

      if (format === '{y}{m}{d}{h}{i}{s}') {
        return '' + y + this.Add0(m) + this.Add0(d) + this.Add0(h) + this.Add0(mm) + this.Add0(s) + this.Add0(ms);
      }

      if (format === '{y}-{m}-{d}') {
        return y + '-' + this.Add0(m) + '-' + this.Add0(d);
      }
    },
    Add0: function Add0(m) {
      return m < 10 ? '0' + m : m;
    }
  }
};